<template>
  <span>
    <el-button :type="type" :size="size" @click="showPrintDialog">打印</el-button>
    <el-dialog
        title="打印订单"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        width="980px"
        append-to-body>
      <div v-if="order" ref="printContent" class="print-sheet">
        <div class="print-title">歌缇生物</div>
        <div class="print-meta">
          <div>订单编号：{{ order.order_sn }}</div>
          <div>下单日期：{{ order.create_time }}</div>
          <div>客户名称：{{ getCustomerName(order) }}</div>
          <div>联系人姓名：{{ order.address ? order.address.name : '-' }}</div>
          <div>联系人电话：{{ order.address ? order.address.mobile : '-' }}</div>
          <div class="print-address">收货地址：{{ getAddress(order) }}</div>
        </div>
        <table class="print-table">
          <thead>
            <tr>
              <th style="width: 70px;">序号</th>
              <th>商品名称</th>
              <th style="width: 260px;">商品规格</th>
              <th style="width: 120px;">数量</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in validGoods" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.goods_name }}</td>
              <td>{{ item.specs_name || '-' }}</td>
              <td>{{ getGoodsRemainQuantity(item) }}</td>
            </tr>
            <tr v-if="validGoods.length===0">
              <td colspan="4">商品已退款</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td>{{ goodsTotal }}</td>
            </tr>
          </tbody>
        </table>
        <div class="print-footer">
          <div>备注：{{ order.remark || '' }}</div>
          <div class="print-tips">
            <div>温馨提示：</div>
            <div>1、到货后90天内(无损坏)不影响二次销售，可以申请调换货（运费自理）</div>
            <div>2、货物有残缺、少货、漏货，请24小时内联系仓管，逾期概不负责。</div>
          </div>
          <!--div>业务员名称：</div-->
          <div>打印时间：{{ printTime }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer no-print">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" size="small" @click="printOrder">打印</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
export default {
  name: 'OrderPrint',
  props: {
    order: {
      type: [Object, Boolean],
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      dialogVisible: false,
      printTime: ''
    }
  },
  computed: {
    validGoods() {
      return (this.order && this.order.goods ? this.order.goods : []).filter(item => this.getGoodsRemainQuantity(item) > 0)
    },
    goodsTotal() {
      return this.validGoods.reduce((total, item) => total + this.getGoodsRemainQuantity(item), 0)
    }
  },
  methods: {
    getGoodsRemainQuantity(item) {
      return Math.max((parseInt(item.quantity) || 0) - (parseInt(item.refund_quantity) || 0), 0)
    },
    getCustomerName(item) {
      if (item.address && item.address.name) {
        return item.address.name
      }
      return item.member ? item.member.name : '-'
    },
    getAddress(item) {
      if (!item.address) {
        return '-'
      }
      return (item.address.province_name || '') + (item.address.city_name || '') + (item.address.district_name || '') + (item.address.address || '')
    },
    showPrintDialog() {
      this.printTime = this.formatDateTime(new Date())
      this.dialogVisible = true
    },
    formatDateTime(date) {
      var pad = num => (num < 10 ? '0' + num : num)
      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds())
    },
    printOrder() {
      this.$nextTick(() => {
        this.$print(this.$refs.printContent)
      })
    }
  }
}
</script>

<style scoped>
.print-sheet {
  width: 900px;
  margin: 0 auto;
  padding: 24px 28px;
  color: #3c4d8f;
  background: #fff;
  font-size: 14px;
  line-height: 1.6;
}
.print-title {
  margin-bottom: 22px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
.print-meta {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px 28px;
  margin-bottom: 18px;
}
.print-address {
  grid-column: 1 / 4;
  font-weight: bold;
}
.print-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: center;
}
.print-table th,
.print-table td {
  border: 1px solid #7b84bd;
  padding: 8px 10px;
  word-break: break-all;
}
.print-table th {
  font-weight: bold;
}
.print-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 28px;
  margin-top: 28px;
}
.print-tips {
  grid-column: 1 / 3;
}
@media print {
  .print-sheet {
    width: auto;
    padding: 0;
    color: #000;
  }
}
</style>
